<script setup lang="ts">

import { ref } from 'Vue'
import ProductModal from './ProductModal.vue'

const props = defineProps<{
	choice: PartChoice
	closePicker: () => void
	setChoiceAndClosePicker: (value: any) => void
}>()

const showModal = ref(false);
const choice = props.choice
const setChoiceAndClosePicker = props.setChoiceAndClosePicker
const closePicker = props.closePicker

const onClick = function(choice: PartChoice) {
	setChoiceAndClosePicker(choice.value)

	closePicker()
}

</script>

<template>
	<div class="product-card">
		<div class="product-card__head">
			<img v-if="choice.img.url" :src="choice.img.url" :width="choice.img.width" :height="choice.img.height" class="product-card__img" loading="lazy" :alt="choice.prodNo">
			<div class="product-card__head-btn-wrap">
				<button @click="showModal = true" type="button" class="product-card__more-info-btn button is-style-outline">Klikk for mer info</button>
			</div>
		</div>
		<div class="product-card__body">
			<h3 class="product-card__description" v-html="choice.description"></h3>
			<div class="product-card__prod-no">Produktnummer: {{choice.prodNo}}</div>
			<table class="product-card__details">
				<tbody>
					<tr v-for="detail in choice.details">
						<th>{{detail.title}}</th>
						<td>{{detail.value ? detail.value : '—'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<button @click="onClick(choice)" type="button" class="product-card__btn button is-style-outline">Velg produkt</button>
		<Teleport to="body">
			<!-- use the modal component, pass in the prop -->
			<ProductModal :show="showModal" @close="showModal = false" :choice="choice" :onClick="onClick">
			</ProductModal>
		</Teleport>
	</div>
</template>

<style lang="scss" scoped>
.product-card {
	$block: '.product-card';

	display: flex;
	flex-direction: column;

	#{$block} {
		&__head {
			position: relative;
			margin-bottom: 20px;
			background: #fff;
			border: 1px solid #b3b3b3;

			&:after {
				content: "";
				display: block;
				padding-bottom: 100%;
				width: 100%;
			}
		}

		&__img {
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			display: block;
			width: 100%;
			height: 100%;
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}

		&__head-btn-wrap {
			background-color: #fff;
			position: absolute;
			right: 0;
			top: 0;
			border-radius: 2px;
		}

		&__more-info-btn {
			font-size: 1rem;
			text-transform: none;
			padding: 10px 15px;
			color: #000;
			border-color: #000;

			&:hover {
				color: #fff;
			}
		}

		&__prod-no {
			font-weight: 400;
			font-size: var(--wp--preset--font-size--tiny);
			margin-bottom: 0.5rem;
		}

		&__description {
			font-weight: 600;
			font-size: 1.2rem;
			margin-bottom: 0.25rem;

			:deep(p) {
				margin-top: 0;
				margin-bottom: 0;
				line-height: 1.4;
			}

			:deep(p:not(:last-child)) {
				margin-bottom: 0.5rem;
			}
		}

		&__body {
			flex-grow: 1;
			margin-bottom: 10px;
			font-size: var(--wp--preset--font-size--small);
		}

		&__details {
			font-size: var(--wp--preset--font-size--tiny);

			th {
				font-weight: 700;
				text-align: left;
				padding-right: 0.5rem;
			}
		}

		&__btn {
			width: 100%;
		}
	}
}
</style>
